import React, { useEffect, useState } from "react";
import classes from "./ServicesComponents.module.scss";
import ServicesContainer from "./ServicesContainer";
import axios from "axios";
import IssuingMode from "./IssuingMode";
import ReceivingMode from "./ReceivingMode";
import LoadingDots from "../UI/LoadingDots";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ClientServices = ({ connKey }) => {
  const [issueMode, setIssueMode] = useState(null);
  const [receiveMode, setReceiveMode] = useState(null);
  const [issueMsg, setIssueMsg] = useState(null);
  const [recMsg, setRecMsg] = useState(null);
  const [isIssueLoading, setIsIssueLoading] = useState(null);
  const [isRecLoading, setIsRecLoading] = useState(null);

  useEffect(() => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetTransformerData",
            args: {
              type: "profile",
            },
          },
          id: 322,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res?.data?.result && res?.data?.result?.Status === "OK") {
          setIssueMode(res?.data?.result?.Result?.device?.Mode);
          setReceiveMode(res?.data?.result?.Result?.org?.ModeREI);
        }
      });
  }, []);

  const onChangeMode = (action) => {
    let extension;
    if (action === "IEI") {
      extension = "ChangeMode";
      setIsIssueLoading(true);
    }
    if (action === "REI") {
      extension = "ChangeModeREI";
      setIsRecLoading(true);
    }
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: `EUeInvoices.${extension}`,
            args: {
              DeviceId: connKey,
              Mode: "PROD",
            },
          },
          id: 321,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result) {
          if (action === "IEI") {
            setIsIssueLoading(false);
            if (res.data.result.Status === "OK") setIssueMode("PROD");
            else if (res.data.result.Status === "Error") {
              setIssueMode("error");
              setIssueMsg(res.data.result.Reason || "An error occured.");
            }
          } else if (action === "REI") {
            setIsRecLoading(false);
            if (res.data.result.Status === "OK") setReceiveMode("PROD");
            else if (res.data.result.Status === "Error") {
              setReceiveMode("error");
              setRecMsg(res.data.result.Reason || "An error occured.");
            }
          }
        }
      });
  };

  return (
    <div className="py-4">
      <section className={classes.switchContainer}>
        {!isIssueLoading ? (
          <IssuingMode
            onChangeMode={onChangeMode}
            currentMode={issueMode}
            errorMsg={issueMsg}
          />
        ) : (
          <LoadingDots className="d-flex justify-content-center" />
        )}
        {!isRecLoading ? (
          <ReceivingMode
            onChangeMode={onChangeMode}
            currentMode={receiveMode}
            errorMsg={recMsg}
          />
        ) : (
          <LoadingDots className="d-flex justify-content-center" />
        )}
      </section>
      <ServicesContainer />
    </div>
  );
};

export default ClientServices;
